<template>
    <v-chip-group>
        <v-chip v-for="user in users" small :dark="dark" :color="user.color" :key="user.value">
            {{ user.text }}
        </v-chip>
    </v-chip-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import OrderBy from 'lodash/orderBy';
export default {
    name: 'label-users',
    data: () => ({}),
    created() {},
    mounted() {},
    props: {
        value: {},
        color: {
            default: null,
        },
        dark: {
            default: true,
        },
    },
    watch: {},
    computed: {
        ...mapGetters(['usersLabels']),
        users() {
            if (this.value) {
                return OrderBy(
                    this.value.map((r) => {
                        return {
                            text: this.usersLabels.find((u) => u.name === r).fullname,
                            value: r,
                            color: this.userColor(r),
                        };
                    }),
                    ['value'],
                    ['asc'],
                );
            }
            return [];
        },
    },
    methods: {
        userColor(role) {
            if (this.color) {
                return this.color;
            }
            return 'light-blue darken-2';
        },
    },
};
</script>
